import React from 'react';

const CheckboxRenderer = ({ field, value, onChange, error, readOnly }) => {
  return (
    <div className="mb-4">
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={readOnly}
          className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
        <span className="text-sm font-medium text-gray-700">
          {field.label}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </span>
      </label>
      {field.help_text && (
        <p className="text-xs text-gray-500 ml-6 mt-1">{field.help_text}</p>
      )}
      {error && <p className="text-xs text-red-500 ml-6 mt-1">{error}</p>}
    </div>
  );
};

export default CheckboxRenderer;
